import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

export interface ISessionRow {
  sessionId?: string;
  deviceId: string;
  deviceType: string;
  device: string;       // mapped from deviceName
  ip: string;           // mapped from ipAddress
  location: string;
  lastActive: Date;
  createdAt?: Date;
  current: boolean;
}

@Component({
  selector: 'app-active-sessions',
  standalone: true,
  imports: [CommonModule,TooltipModule],
  templateUrl: './active-sessions.component.html',
  styleUrl: './active-sessions.component.css'
})
export class ActiveSessionsComponent implements OnChanges {
  @Input() activeSessions: ISessionRow[] = [];
  @Output() revoke = new EventEmitter<ISessionRow>();

  currentPage = 1;
  pageSize = 10;
  paginatedSessions: ISessionRow[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activeSessions']) {
      this.currentPage = 1;
      this.updatePagination();
    }
  }

  updatePagination() {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    this.paginatedSessions = this.activeSessions.slice(startIndex, startIndex + this.pageSize);
  }

  nextPage() {
    if (this.currentPage * this.pageSize < this.activeSessions.length) {
      this.currentPage++;
      this.updatePagination();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  onPageSizeChange(event: Event) {
    this.pageSize = Number((event.target as HTMLSelectElement).value);
    this.currentPage = 1;
    this.updatePagination();
  }

  get totalEntries() {
    return this.activeSessions.length;
  }

  get startIndex() {
    return this.totalEntries === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
  }

  get endIndex() {
    const end = this.currentPage * this.pageSize;
    return end > this.totalEntries ? this.totalEntries : end;
  }

  confirmRevoke(session: ISessionRow) {
    this.revoke.emit(session);
  }
}
